module.exports = __webpack_public_path__ + "img/only-windows.0fd108fc.svg";